export default {"src":"/_next/static/media/soft-honkbal.780c46f3.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};